// Low-cost launch (u15 D1): the one place platform hostnames live. Worker env vars
// (FREE_SITE_BASE_DOMAIN, MEDIA_HOST, SAAS_CNAME_TARGET, APP_ORIGIN, VERIFY_ORIGIN) must match;
// the drift test in api-worker enforces it. Plain literals only: scripts import this file with
// Node's type stripping.

/** Platform surfaces: app., verify., notify., assets. */
export const PLATFORM_DOMAIN = 'edgepage.co';
/** Tenant sites (`{sub}.`, `preview-{sub}.`) and tenant media — a separate registrable domain. */
export const SITES_DOMAIN = 'edgepage.site';

export const APP_HOST = `app.${PLATFORM_DOMAIN}`;
export const VERIFY_HOST = `verify.${PLATFORM_DOMAIN}`;
export const PLATFORM_ASSET_HOST = `assets.${PLATFORM_DOMAIN}`;
export const TENANT_MEDIA_HOST = `media.${SITES_DOMAIN}`;
/** What customers CNAME their own domain to (Cloudflare for SaaS, u13 D1). */
export const SAAS_CNAME_TARGET = `sites.${SITES_DOMAIN}`;
export const SAAS_FALLBACK_HOST = `fallback.${SITES_DOMAIN}`;
